import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { employerData } from './slice'
import { userAPI } from 'features/users/api'
import { RequestUtils } from 'utils'

function* getData({ payload: { id, params = {} } }) {
  try {
    let requestParams = {
      includes: ['avatar', 'fullEmployerProfile'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(userAPI.getPublicUser, id, requestParams)

    const { data } = response

    yield put(employerData.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(employerData.getDataError(message))
  }
}

function* watchGetData() {
  yield takeLatest(employerData.getData, getData)
}

export function* dataSaga() {
  yield all([fork(watchGetData)])
}
